import { render, staticRenderFns } from "./TalkObjectTree.vue?vue&type=template&id=78d34a3c&scoped=true"
import script from "./TalkObjectTree.vue?vue&type=script&lang=js"
export * from "./TalkObjectTree.vue?vue&type=script&lang=js"
import style0 from "./TalkObjectTree.vue?vue&type=style&index=0&id=78d34a3c&prod&lang=css"
import style1 from "./TalkObjectTree.vue?vue&type=style&index=1&id=78d34a3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d34a3c",
  null
  
)

export default component.exports